export const CALENDLY_URL = "https://calendly.com/dev-sridhar55/consult-call";
export const EMAIL = "dev.sridhar55@gmail.com";
export const PITCH_PASSWORD = "rare2026";
